export const pic_width = 550;
export const pic_height = pic_width * 0.75;
